import Login from './views/Login.vue'
import Dashboard from './views/Dashboard.vue'
import ServiceForm from './views/ServiceForm.vue'
import ServiceDetail from './views/ServiceDetail.vue'
import DeploymentLog from './views/DeploymentLog.vue'
import System from './views/System.vue'

export const routes = [
  { path: '/login', name: 'login', component: Login, meta: { layout: 'blank' } },
  { path: '/', name: 'dashboard', component: Dashboard, meta: { requiresAuth: true } },
  { path: '/services/new', component: ServiceForm, meta: { requiresAuth: true } },
  { path: '/services/:id', component: ServiceDetail, meta: { requiresAuth: true } },
  { path: '/services/:id/edit', component: ServiceForm, meta: { requiresAuth: true } },
  { path: '/services/:id/onboarding', component: ServiceForm, meta: { requiresAuth: true } },
  { path: '/deployments/:id', component: DeploymentLog, meta: { requiresAuth: true } },
  { path: '/system', component: System, meta: { requiresAuth: true } },
]
